import CustomerList from '@/views/Portal/CustomerList.vue';
import { Route } from '../../route.model';

const portalCustomerList = new Route(
  '/portal/customer-list',
  'portal-customer-list',
  CustomerList,
  {
    requiresAuth: true,
    isResponsive: true,
    zendesk: {
      disabled: true
    }
  }
);

export { portalCustomerList };
export default portalCustomerList;
